
function animationDone() {
    console.log("Caught animation done listener");
}


$('img').on('load', function () {
    setTimeout(function () {
        $(window).trigger('resize');
    }, 300);
});

function animateBike(percent) {

    var speed_multiplier = 5;
    var num_sprite_rows = 9;
    var num_sprite_columns = 11;
    var num_states = num_sprite_rows * num_sprite_columns;
    var sprite_index = Math.floor(num_states * (percent * speed_multiplier)) % num_states;
    var sprite_width = $('.bike').width();
    var sprite_height = $('.bike').height();

    var x_offset = (sprite_index * sprite_width) % (num_sprite_columns * sprite_width);
    var y_offset = (Math.floor(sprite_index / num_sprite_columns) * sprite_height);

    $('.bike').css('background-position', -x_offset + 'px ' + -y_offset + 'px');
}

function moveBike(percent) {

    percent = Math.min(1, percent);
    var left = Math.floor(percent * 50);
    var bikeWidth = $('.bike').width();
    var marginLeft = -bikeWidth + (percent * (bikeWidth / 2));

    $('.bike').css('left', left + '%');
    $('.bike').css('marginLeft', marginLeft + 'px');
}

var viewportHeight = 0;

$(document).ready(function () {
    var time;
    var sum_time = 0;
    var end_time = 1000;

    // TEST
    viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    //console.log('Height : ' + viewportHeight);

    function draw() {

        if (sum_time >= end_time) {
            return;
        }

        requestAnimationFrame(draw);

        var now = new Date().getTime();
        var dt = now - (time || now);
        sum_time += dt;

        time = now;

        var movePercent = sum_time / end_time;
        var fractionMoved = $('.pages .page').size() * 2;
        var animatePercent = movePercent / fractionMoved;

        animateBike(animatePercent);
        moveBike(movePercent);
    }

    setTimeout(function () {
        draw();
    }, 1500);
});

$(window).resize(function () {
    var width = $(window).width();

    // TEST
    //viewportHeightNew = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    //console.log('Offset : ' + (viewportHeightNew - viewportHeight));


    //var mobileOffSet = 0;
    //if ((viewportHeightNew - viewportHeight) > 10) {
    //    //mobileOffSet = (viewportHeightNew - viewportHeight) * -1;
    //    mobileOffSet = -52;
    //}

    //console.log('Height diff : ' + (viewportHeightNew - viewportHeight) + " Mobile offset = " + mobileOffSet);

    $('.pages .page').each(function (idx, item) {
        $(this).css('width', width + 'px');
        $(this).css('left', ((width * idx)) + 'px');
    });

    var width = $('.pages .page').size() * width;
    $('.pages').css('width', width);

    var height = $(window).height() - $('.page-header').height();
    $('.scroll').css('height', height + 'px');

    var top = $('.road:first').position().top + 100;
    $('.bike').css('top', top + 'px');
});

$(window).trigger('resize');

var lastScrollPercent = 0;

$.jInvertScroll(['.pages, .header-image'],
    {
        onScroll: function (percent) {
            lastScrollPercent = percent;
            animateBike(percent);
        }
    });

function snapToPageAtIndex(index) {

    if (shouldSnap === false) {
        return;
    }

    shouldSnap = false;

    var target = '.pages .page' + (index + 1);
    var left = $(target).position().left;
    var total = $('.pages').width();
    var percent = left / (total - $(window).width()) * 100;
    var height = $('html').height();
    var final = ((height - $(window).height()) / 100 * percent);

    console.log("html, body animate scrollTop %o ", final)
    $('html, body').animate({ scrollTop: final }, 500, 'easeInOutExpo', function () {

        if (index == (totalSlides - 1)) {
            final = parseInt($('.page--outro').css('left'));
            $('.scroll.pages').css('left', '-' + final + 'px');
        }
        setTimeout(function () {
            shouldSnap = true;
        }, 100);
    });
}

var lastScrollTop = 0;
var scrollingRight = false;
var shouldSnap = true;

$('.road-banner').click(function () {
    var targetPage = parseInt($(this).data('target-page'));

    snapToPageAtIndex(targetPage - 1);
});
